import React from 'react';
import ReactDOM from 'react-dom';
//import { Button } from "./Button";
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App></App>
  </React.StrictMode>,
  document.getElementById('root')
);

